export default __webpack_public_path__ + "static/media/low-tension-icon.d50ad7b4.svg";